import {Pipe, PipeTransform} from '@angular/core';
import {Unit, UnitGroup} from "../models/sob.enum";

@Pipe({
  name: 'benefitValueType',
  standalone: true
})
export class BenefitValueTypePipe implements PipeTransform {
  // Define rules using a more TypeScript-friendly approach
  private readonly combinedRules = new Map<string, { singular: string, plural: string }>([
    [`${Unit.Amount}-${UnitGroup.Money}`, {singular: '', plural: ''}],
    [`${Unit.Amount}-${UnitGroup.Percentage}`, {singular: '%', plural: '%'}],
    [`${Unit.Months}-${UnitGroup.Months}`, {singular: ' Month', plural: ' Months'}],
    [`${Unit.Years}-${UnitGroup.Age}`, {singular: ' Year', plural: ' Years'}],
  ]);

  private readonly unitRules = new Map<Unit, { singular: string, plural: string }>([
    [Unit.Days, {singular: ' Day', plural: ' Days'}],
    [Unit.Nights, {singular: ' Night', plural: ' Nights'}],
    [Unit.Months, {singular: ' Month', plural: ' Months'}],
    [Unit.Years, {singular: ' Year', plural: ' Years'}],
    [Unit.Visits, {singular: ' Visit', plural: ' Visits'}],
    [Unit.Events, {singular: ' Event', plural: ' Events'}],
    [Unit.Percentage, {singular: '%', plural: '%'}],
    [Unit.CoPay, {singular: ' Co-Pay', plural: ' Co-Pay'}],
    [Unit.Business, {singular: ' Business', plural: ' Business'}],
    [Unit.Economy, {singular: ' Economy', plural: ' Economy'}],
    [Unit.CabinClass, {singular: ' Cabin Class', plural: ' Cabin Class'}],
    [Unit.RoomType, {singular: ' Room Type', plural: ' Room Type'}],
    [Unit.SemiPrivateRoom, {singular: ' Semi-private room', plural: ' Semi-private rooms'}],
    [Unit.StandardPrivateOrSemiPrivateRoom, {
      singular: ' Standard Private or Semi-Private room',
      plural: ' Standard Private or Semi-Private rooms'
    }],
    [Unit.SuperiorPrivateRoom, {singular: ' Superior private room', plural: ' Superior private rooms'}],
  ]);

  private readonly unitGroupRules = new Map<UnitGroup, { singular: string, plural: string }>([
    [UnitGroup.Day, {singular: ' Day', plural: ' Days'}],
    [UnitGroup.Night, {singular: ' Night', plural: ' Nights'}],
    [UnitGroup.Days, {singular: ' Day', plural: ' Days'}],
    [UnitGroup.Nights, {singular: ' Night', plural: ' Nights'}],
    [UnitGroup.Visit, {singular: ' Visit', plural: ' Visits'}],
    [UnitGroup.Visits, {singular: ' Visit', plural: ' Visits'}],
    [UnitGroup.Events, {singular: ' Event', plural: ' Events'}],
    [UnitGroup.Months, {singular: ' Month', plural: ' Months'}],
    [UnitGroup.Years, {singular: ' Year', plural: ' Years'}],
    [UnitGroup.Percentage, {singular: '%', plural: '%'}],
    [UnitGroup.CoPay, {singular: ' co-pay', plural: ' co-pay'}],
    [UnitGroup.FlightTicket, {singular: ' Flight Ticket', plural: ' Flight Tickets'}],
    [UnitGroup.CabinClass, {singular: ' Cabin Class', plural: ' Cabin Class'}],
    [UnitGroup.RoomType, {singular: ' Room Type', plural: ' Room Types'}],
  ]);

  transform(benefit: any): string {
    if (!benefit.unit && !benefit.unitGroup) return '';

    // Determine if we should use singular or plural form
    const isSingular = (benefit.amount === 1 || benefit.limitAmount === 1);
    const form = isSingular ? 'singular' : 'plural';

    let result: string | undefined;

    // First check for specific unit+unitGroup combinations
    if (benefit.unit && benefit.unitGroup) {
      const combinedKey = `${benefit.unit}-${benefit.unitGroup}`;
      const rule = this.combinedRules.get(combinedKey);
      if (rule) {
        result = rule[form];
      }
    }

    // Then check for unit rules if no combined rule was found
    if (result === undefined && benefit.unit) {
      const rule = this.unitRules.get(benefit.unit);
      if (rule) {
        result = rule[form];
      }
    }

    // Finally check for unitGroup rules if still no rule was found
    if (result === undefined && benefit.unitGroup) {
      const rule = this.unitGroupRules.get(benefit.unitGroup);
      if (rule) {
        result = rule[form];
      }
    }

    return result || '';
  }
}
